/**
 * BillingStatusBadge Component - Sprint 25
 * 
 * Displays billing status with appropriate color coding:
 * - paid (green)
 * - pending (yellow)
 * - overdue (red)
 * - manual_billing (blue)
 * - trial (purple)
 */

import React from 'react';
import { Badge } from '../ui/badge';
import { 
  CheckCircle, 
  Clock, 
  AlertTriangle, 
  FileText, 
  Sparkles 
} from 'lucide-react';

const STATUS_CONFIG = {
  paid: {
    label: 'Paid',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-300',
    icon: CheckCircle,
    iconColor: 'text-emerald-600'
  },
  payment_pending: {
    label: 'Payment Pending',
    color: 'bg-amber-100 text-amber-800 border-amber-300',
    icon: Clock,
    iconColor: 'text-amber-600'
  },
  overdue: {
    label: 'Overdue',
    color: 'bg-red-100 text-red-800 border-red-300',
    icon: AlertTriangle,
    iconColor: 'text-red-600'
  },
  manual_billing: {
    label: 'Manual Billing',
    color: 'bg-blue-100 text-blue-800 border-blue-300',
    icon: FileText,
    iconColor: 'text-blue-600'
  },
  trial: {
    label: 'Trial',
    color: 'bg-purple-100 text-purple-800 border-purple-300',
    icon: Sparkles,
    iconColor: 'text-purple-600'
  }
};

const BillingStatusBadge = ({ status, showIcon = true, size = 'default' }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.manual_billing;
  const IconComponent = config.icon;
  
  const sizeClasses = {
    small: 'text-xs px-2 py-0.5',
    default: 'text-sm px-3 py-1',
    large: 'text-base px-4 py-1.5'
  };

  return (
    <Badge 
      variant="outline" 
      className={`${config.color} ${sizeClasses[size]} flex items-center gap-1.5`}
      data-testid="billing-status-badge"
    >
      {showIcon && <IconComponent className={`w-3.5 h-3.5 ${config.iconColor}`} />}
      {config.label}
    </Badge>
  );
};

export default BillingStatusBadge;
